import React, { useEffect, useState,useImperativeHandle, useRef } from 'react';
import moment from 'moment';
import { Modal, Table, DatePicker, Input, message } from 'antd';
import './index.scss';
import { getRelateTaskList, confirmRelateTask } from '../../../../actions/majorProjects';



//关联任务页面

const { RangePicker } = DatePicker
const { Search } = Input
const RelateProjectModal = (props) => {

  //搜索查询参数
  const [params, setParams] = useState({});
  //当前选中项
  const [selectedItems, setSelectedItems] = useState([]);
  //当前页数
  const [current, setCurrent] = useState(1);

  const [visible, setVisible] = useState(false);
  const [time, setTime] = useState([]);
  const [keyWords, setKeyWords] = useState('');
  const [relateTaskData, setRelateTaskData] = useState([]);
  const [total, setTotal] = useState(0)


  useEffect(() => {
    if(visible){
      if ((time.length === 0) || (time.length === 2)) {
        search(1, getParams())
      }
    }
  }, [time, visible])

  useImperativeHandle(props.refs, () => ({
    changeRelateTaskVisible: changeRelateTaskVisible
  }))

  const changeRelateTaskVisible = (visible) => {
    setVisible(visible);
    setSelectedItems([]);
  }

  const search = (current, params) => {
    let param = {...params, start: current, size: 6, interviewEventId:props.id}; 
    getRelateTaskList(param,function(res){
      if(res.code === 0){
        setRelateTaskData(res.data);
        setTotal(res.count);
      }
    })
  }

  //监听输入关键字改变
  const changeKeyWords = (e) => {
    setKeyWords(e.target.value);
  }

  const changeTime = (dates) => {
    setTime(dates);
  }

  const reset = () => {
    setKeyWords('');
    setTime([]);
    search(1, { queryStr:'',startDate:'',endDate:''});
  }

  const handleCancel = () => {
    setKeyWords('');
    setTime([]);
    changeRelateTaskVisible(false);
  }

  const handleOk = () => {
    handleCancel();
  }

  const columns = [
    {
      key: 'title',
      title: '标题',
      dataIndex: 'title',
      width: '80%',

      render: (text) => (<div className="column-title"><span>{text}</span></div>)
    },
  ];

  const resetKeys = () => {
    setSelectedItems([]);
  }

  const relateTask = () => {
    if (selectedItems.length === 0) {
      message.error('请至少选择一个任务关联！');
      return;
    }
    confirmRelateTask({interviewEventId: props.id, interviewIds:selectedItems },(res) => {
      if(res){
        handleCancel();
        search(1, getParams());
        message.success('关联成功！')
        props.refreshTaskList();
        props.taskListRef.current.searchFirst(1)   //查询项目任务列表
      }
    })
    
  }

  const getParams = () => {
    const startDate = time.length === 0 ?  '' : moment(time[0]).format('YYYY-MM-DD')
    const endDate = time.length === 0 ?  '' : moment(time[1]).format('YYYY-MM-DD')
    const queryStr = keyWords !== undefined ? keyWords : ''
    return { queryStr,startDate,endDate }

  }

  const changePage = (page) => {
    setCurrent(page);
    search(page,getParams());
  }

  const rowSelection = {
    type: 'checkbox',
    selectedRowKeys: selectedItems,
    onChange: (selectedRowKeys, selectedRows) => { console.log(selectedRowKeys); setSelectedItems(selectedRowKeys) }
  }

  return (
    <>
       <Modal
      title="关联任务"
      className="relate-project-modal"
      width='60%'
      visible={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      destroyOnClose
      footer={null}
    >
      <div className="condition">
        <div>
          <span style={{ marginRight: 10, fontFamily: 'MicrosoftYaHei', color: '#a4adc8', fontSize: '15px' }}>创建日期</span>
          <RangePicker
            showClear
            onChange={changeTime}
            value={time}
          />
        </div>
        <div>
          <Search
            placeholder="请输入搜索内容"
            onChange={changeKeyWords}
            value={keyWords}
           onSearch={() => {search(1,getParams())}}
          />
        </div>
        <div>
          <span className="reset" onClick={reset}>重置筛选</span>
        </div>
      </div>
      <div className="table">
        <Table
          className="task-table"
          dataSource={relateTaskData}
          columns={columns}
          scroll={{y:300}}
          rowKey={(record) => record.id}
          rowSelection={rowSelection}
          pagination={{
            current,
            pageSize: 6,
            total,
            onChange: changePage
          }}
        />
      </div>
      <div className="footer">
        <span onClick={resetKeys}>清除选择</span>
        <span onClick={relateTask}>确认关联</span>
      </div>
    </Modal>
    
    </>
  )
}

export default RelateProjectModal



